<template>
  <div class="leftContentBlock h-100" :style="{'background-image':'url('+leftBg+')'}">

    <h5 class="text-white text-center text-lg-left">{{ t('leftContent.header') }}</h5>

    <p class=" mt-lg-4 text-white text-center text-lg-left">{{ t('leftContent.pLeft') }} <br> {{ t('leftContent.pRight') }}</p>

    <p class="text-white text-center text-lg-left">{{t('leftContent.zahrnuje')}}:</p>

    <table class="text-14 text-white mt-4 ml-lg-0 ml-auto mr-auto mb-4">
      <tr>
        <td>
          <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 6L5.5 9.75L13 2.25" stroke="white" stroke-width="2" stroke-linecap="square"/>
          </svg>
        </td>
        <td class="pl-2">
          {{t('leftContent.table.1')}}
        </td>
      </tr>
      <tr>
        <td>
          <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 6L5.5 9.75L13 2.25" stroke="white" stroke-width="2" stroke-linecap="square"/>
          </svg>
        </td>
        <td class="pl-2">
          {{t('leftContent.table.2')}}
        </td>
      </tr>
      <tr>
        <td>
          <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 6L5.5 9.75L13 2.25" stroke="white" stroke-width="2" stroke-linecap="square"/>
          </svg>
        </td>
        <td class="pl-2">
          {{t('leftContent.table.3')}}
        </td>
      </tr>
      <tr>
        <td>
          <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.75 6L5.5 9.75L13 2.25" stroke="white" stroke-width="2" stroke-linecap="square"/>
          </svg>
        </td>
        <td class="pl-2">
          {{t('leftContent.table.4')}}
        </td>
      </tr>
    </table>

<!--    <img v-bind:src="leftBg" alt=""/>-->
  </div>

</template>


<script>
import {ref} from 'vue'
import {useI18n} from 'vue-i18n'

import leftBg from '@/assets/imgs/left-bg.webp';

export default {
  name: "LeftContentBlock",
  setup() {
    const {t} = useI18n({useScope: 'global'})
    const select = ref(0)
    return {t, select}
  },
  data() {
    return {
      leftBg
    }
  },
}
</script>

<style scoped>


</style>